export const base64ToFile = base64 => {
  var image = `data:image/png;base64,${base64}`
  return image
}
